module.exports = __webpack_public_path__ + "img/bg_pop_top.1ac18010.png";